const actions = {
  async getDashboardStatistics({ commit }, params) {
    const res = await this.$repositories.adminDashboard.getDashboardStatistics(
      params
    )

    return res.data
  },
  async getHolidayGreetingCard({ commit }, params) {
    const res = await this.$repositories.adminDashboard.getHolidayGreetingCard(
      params
    )

    return res.data
  },
  async updateHolidayCard({ commit }, params) {
    const res = await this.$repositories.adminDashboard.updateHolidayCard(
      params
    )

    return res.data
  },
  async getHolidayGreetingCardGallery({ commit }, params) {
    const res =
      await this.$repositories.adminDashboard.getHolidayGreetingCardGallery(
        params
      )

    return res.data
  },
  async deleteImageFromGallery({ commit }, params) {
    const res = await this.$repositories.adminDashboard.deleteImageFromGallery(
      params
    )

    return res.data
  },
  async updateHolidayGreetingCardGalleryText({ commit }, params) {
    const res =
      await this.$repositories.adminDashboard.updateHolidayGreetingCardGalleryText(
        params
      )

    return res.data
  },
  async getProperllyAlerts({ commit }, params) {
    const res = await this.$repositories.adminDashboard.getProperllyAlerts(
      params
    )

    return res.data
  },
  async addProperllyAlerts({ commit }, params) {
    const res = await this.$repositories.adminDashboard.addProperllyAlerts(
      params
    )

    return res.data
  },
  async updateProperllyAlerts({ commit }, params) {
    const res = await this.$repositories.adminDashboard.updateProperllyAlerts(
      params
    )

    return res.data
  },
  async deleteProperllyAlerts({ commit }, params) {
    const res = await this.$repositories.adminDashboard.deleteProperllyAlerts(
      params
    )

    return res.data
  },
  async getAllUsers({ commit }, params) {
    const res = await this.$repositories.adminDashboard.getAllUsers(params)

    return res.data
  },
  async getAllUsersDetails({ commit }, params) {
    const res = await this.$repositories.adminDashboard.getAllUsersDetails(
      params
    )

    return res.data
  },
  async addVideoToLib({ commit }, params) {
    const res = await this.$repositories.adminDashboard.addVideoToLib(params)

    return res.data
  },
  async updateVideoToLib({ commit }, params) {
    const res = await this.$repositories.adminDashboard.updateVideoToLib(params)

    return res.data
  },
  async deleteVideoToLib({ commit }, params) {
    const res = await this.$repositories.adminDashboard.deleteVideoToLib(params)

    return res.data
  },
  async getVideoToLib({ commit }, params) {
    const res = await this.$repositories.adminDashboard.getVideoToLib(params)

    return res.data
  },
  async deleteUser({ commit }, params) {
    const res = await this.$repositories.adminDashboard.deleteUser(params)

    return res.data
  },
  async getAllSubscriber({ commit }, params) {
    const res = await this.$repositories.adminDashboard.getAllSubscriber(params)

    return res.data
  },
  async verifySubscriber({ commit }, params) {
    const res = await this.$repositories.adminDashboard.verifySubscriber(params)

    return res.data
  },
  async usertoAdminChange({ commit }, params) {
    const res = await this.$repositories.adminDashboard.usertoAdminChange(params)

    return res.data
  },
  async suspendSubscriber({ commit }, params) {
    const res = await this.$repositories.adminDashboard.suspendSubscriber(params)

    return res.data
  },
}

export default actions
